module.exports = __webpack_public_path__ + "prod/1.42.2/img/lszz.0572fb6c.png";